import type { DirectiveBinding } from 'vue'
const tooltipMap = new WeakMap<
  HTMLElement,
  {
    tooltipElement: HTMLElement
    showTooltip: () => void
    hideTooltip: () => void
  }
>()

// 为了简单，直接操作 DOM 显示 tooltip，
// 实际开发中也可以用组件或者更复杂的样式控制
const createTooltip = (message: string): HTMLElement => {
  const tooltip = document.createElement('div')
  tooltip.textContent = message
  tooltip.style.position = 'absolute'
  tooltip.style.backgroundColor = '#333'
  tooltip.style.color = '#fff'
  tooltip.style.padding = '5px 10px'
  tooltip.style.borderRadius = '4px'
  tooltip.style.fontSize = '12px'
  tooltip.style.zIndex = '1000'
  tooltip.style.pointerEvents = 'none'
  tooltip.style.visibility = 'hidden'
  tooltip.style.transition = 'opacity 0.2s'
  tooltip.style.opacity = '0'
  return tooltip
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const tooltipMessage = binding.value
    if (!tooltipMessage) return

    const tooltipElement = createTooltip(tooltipMessage)
    document.body.appendChild(tooltipElement)

    const showTooltip = () => {
      // 显示逻辑
    }
    const hideTooltip = () => {
      // 隐藏逻辑
    }

    // 将 DOM 元素和数据关联起来
    tooltipMap.set(el, { tooltipElement, showTooltip, hideTooltip })

    el.addEventListener('mouseenter', showTooltip)
    el.addEventListener('mouseleave', hideTooltip)
  },
  unmounted(el: HTMLElement) {
    const data = tooltipMap.get(el)
    if (data) {
      document.body.removeChild(data.tooltipElement)
      el.removeEventListener('mouseenter', data.showTooltip)
      el.removeEventListener('mouseleave', data.hideTooltip)
    }
  },
}
